import { useState, useEffect } from 'react';

function useSessionStorageState(key, initialValue, isDate = false) {
    const [state, setState] = useState(() => {
        try {
            const item = sessionStorage.getItem(key);
            if (item !== null) {
                if (isDate) return new Date(item);
                try {
                    return JSON.parse(item);
                } catch {
                    return item; // Fallback for plain strings
                }
            }
        } catch (error) {
            console.warn(`Error reading sessionStorage key "${key}":`, error);
        }
        return initialValue;
    });

    useEffect(() => {
        try {
            if (state === undefined || state === null) {
                sessionStorage.removeItem(key);
            } else {
                if (isDate && state instanceof Date) {
                    sessionStorage.setItem(key, state.toISOString());
                } else if (typeof state === 'string') {
                    sessionStorage.setItem(key, state);
                } else {
                    sessionStorage.setItem(key, JSON.stringify(state));
                }
            }
        } catch (error) {
            console.warn(`Error setting sessionStorage key "${key}":`, error);
        }
    }, [key, state, isDate]);

    return [state, setState];
}

export default function useEstadoCuentaFiltros() {
    const [periodoEstadoCuenta, setPeriodoEstadoCuenta] = useSessionStorageState('conciliacion_periodo', new Date(), true);
    const [tipoMovimiento, setTipoMovimiento] = useSessionStorageState('conciliacion_tipoMovimiento', '');
    const [cuentaSeleccionada, setCuentaSeleccionada] = useSessionStorageState('conciliacion_cuentaSeleccionada', '');
    const [activeTab, setActiveTab] = useSessionStorageState('conciliacion_activeTab', 'por-conciliar');

    return {
        periodoEstadoCuenta,
        setPeriodoEstadoCuenta,
        tipoMovimiento,
        setTipoMovimiento,
        cuentaSeleccionada,
        setCuentaSeleccionada,
        activeTab,
        setActiveTab
    };
}
